import ErrorManager from '@/common/utils/ErrorManager';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import { RootState } from '@/plugins/store';
import { ActionTree, Commit } from 'vuex';
import { ProjetListActions } from './action-types';
import { PROJET_LIST } from './mutation-types';
import { ProjetListState } from './state';
import ProjetService, { ProjetListPayload } from '@/modules/Common/service/ProjetService';
import { Chantier } from '@/models/Chantier';


interface ProjetListActionType {
    commit: Commit;
    state: ProjetListState;
}

export const actions: ActionTree<ProjetListState, RootState> = {
    async [ProjetListActions.GET_PROJET_LIST](
        { commit }: ProjetListActionType,
        payload: ProjetListPayload
    ): Promise<void> {
        commit(PROJET_LIST.SET_PAGE, payload.page);
        commit(PROJET_LIST.SET_LOADING, true);
        ProjetService.getProjets(payload)
            .then(async (response: any) => {
                if (response !== undefined || response.status !== undefined) {
                    if (response.status !== 200) {
                        commit(PROJET_LIST.SET_ERROR, true);
                        commit(PROJET_LIST.SET_LOADING, false);
                        commit(
                            `errorToaster/${ERROR.SET_MESSAGE}`,
                            await ErrorManager.processErrorCustomMessage(
                                response.status,
                                'app.error.undefined'
                            ),
                            { root: true }
                        );
                    }
                    const chantiers: Chantier[] = response.data.content;
                    if (payload.page === 0) {
                        commit(PROJET_LIST.SET_SCROLL, 0);
                        commit(PROJET_LIST.SET_ITEMS, chantiers);
                    } else {
                        commit(PROJET_LIST.ADD_ITEMS, chantiers);
                    }
                    commit(PROJET_LIST.SET_PAGES, parseInt(response.headers.pages) || 0);
                    commit(PROJET_LIST.SET_LOADING, false);
                } else {
                    commit(PROJET_LIST.SET_ERROR, true);
                    commit(PROJET_LIST.SET_LOADING, false);
                    commit(
                        `errorToaster/${ERROR.SET_MESSAGE}`,
                        await ErrorManager.processErrorCustomMessage(
                            response.status,
                            'app.error.undefined'
                        ),
                        { root: true }
                    );
                }
            })
            .catch(async (error: any) => {
                commit(PROJET_LIST.SET_ERROR, true);
                commit(PROJET_LIST.SET_LOADING, false);
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processError(error),
                    { root: true }
                );
            });
    },
};
